/* eslint-disable @typescript-eslint/restrict-plus-operands */
import { BaseHandler } from './base.handler';
import TireProfileAPI from 'api/tire-pressure';
import { setIsLoading, setTireSensorData } from 'store/tire.sensor.slice';

export default class TireSensorHandler extends BaseHandler {
  private readonly api: TireProfileAPI;
  constructor() {
    super();

    this.api = new TireProfileAPI();
  }

  /**
   * Get Asset Tire Data
   */
  async getAssetTires(assetId: string) {
    this.dispatch(setIsLoading(true));
    try {
      const tireFitmentData = await this.api.getAssetTires(assetId);
      this.dispatch(
        setTireSensorData({
          assetId,
          data: tireFitmentData,
        })
      );

      this.dispatch(setIsLoading(false));
    } catch (error: any) {
      let msg: string = '';

      if (error.isAxiosError) {
        msg = error?.response?.data?.message as string;
      }

      this.handleError(
        'An error occurred while retrieving the asset tire data: ' + msg
      );
      this.dispatch(setIsLoading(false));
    }
  }

  /**
   * Update Asset Tire Sensor Data
   */
  async updateAssetTireSensor(assetId: string, payload: any[]) {
    this.dispatch(setIsLoading(true));
    try {
      const tireFitmentData = await this.api.updateAssetTireSensor(
        { assetTires: payload },
        assetId
      );
      this.dispatch(
        setTireSensorData({
          assetId,
          data: tireFitmentData,
        })
      );

      this.dispatch(setIsLoading(false));
    } catch (error: any) {
      let msg: string = '';

      if (error.isAxiosError) {
        msg = error?.response?.data?.message as string;
      }

      this.handleError(
        'An error occurred while updating the asset tire sensor data: ' + msg
      );
      this.dispatch(setIsLoading(false));
    }
  }
}
